import account from './account';
import admin from './admin';
import common from './common';
import dialog from './dialog';
import { people } from './people';
import { persistedStorage } from './persisted-storage';


export const rootReducer = {
  account,
  admin,
  common,
  dialog,
  persistedStorage,
  people,
};

export default rootReducer;
